<template>
  <div>
    <div justify="center">
      <div class="d-flex mt-2" :class="{'d-flex-column': isFlexColumn}">
        <div class="mr-10">
          <span class="pr-2">{{text}}</span>
          <span class="border" :style="`background-color : ${disableOnBtn ? 'lightgray' : '#1976d2'}`">
            <c-btn :disabled="disableOnBtn" color="white" icon iconName="remove" x-small @click="countDown"/>
          </span>
          <span class="pl-2 pr-2 border">{{ count }}</span>
          <span class="border" :style="`background-color : ${disableOnBtn ? 'lightgray' : '#1976d2'}`">
            <c-btn :disabled="disableOnBtn" color="white" icon iconName="add" x-small @click="countUp"/>
          </span>
        </div>
        <div>
          <span class="pr-2">{{text2}}</span>
          <span class="border" :style="`background-color : ${disableOffBtn ? 'lightgray' : '#1976d2'}`">
            <c-btn :disabled="disableOffBtn" color="white" icon iconName="remove" x-small @click="countDown2"/>
          </span>
          <span class="pl-2 pr-2 border">{{ count2 }}</span>
          <span class="border" :style="`background-color : ${disableOffBtn ? 'lightgray' : '#1976d2'}`">
            <c-btn :disabled="disableOffBtn" color="white" icon iconName="add" x-small @click="countUp2"/>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PassengerCount',
  props: {
    text: {
      type: String,
      default: "탑승",
    },
    text2: {
      type: String,
      default: "하차",
    },
    initialCount: {
      type: Number,
      default: 0,
    },
    initialCount2: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
    count2: {
      type: Number,
      default: 0,
    },
    disableOnBtn: {
      type: Boolean,
      default: false,
    },
    disableOffBtn: {
      type: Boolean,
      default: false,
    },
    isFlexColumn: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.count = this.initialCount;
    this.count2 = this.initialCount2;
    this.$emit('update:count', this.count)
    this.$emit('update:count2', this.count2)
  },
  watch: {
    initialCount(value) {
      this.count = value
    },
    initialCount2(value) {
      this.count2 = value
    }
  },
  methods: {
    countUp : function(){
      this.count++;
      this.$emit('update:count', this.count)
    },
    countDown : function(){
      this.count = this.count === 0 ? 0 : this.count - 1;
      this.$emit('update:count', this.count)
    },
    countUp2 : function(){
      this.count2++;
      this.$emit('update:count2', this.count2)
    },
    countDown2 : function(){
      this.count2 = this.count2 === 0 ? 0 : this.count2 - 1;
      this.$emit('update:count2', this.count2)
    },
  }
}
</script>
<style scoped>
.lightblue {
  background-color: lightblue !important;
}
.iconSize{
  font-size: 15px;
}
.border {
  border: 1px solid rgba(0, 0, 0, 0.6)
}
.d-flex-column {
  flex-direction: column;
}
</style>
